import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'
import { TmApiError } from '@/core/error/transport/tmApiError'

export class TmApiPreconditionFailedError extends TmApiError {
  protected code: TmTransportHttpErrorCode = 412

  public name: string = 'TmApiPreconditionFailedError'
}
